import { useSelector } from 'react-redux'

import {
  AWO_PMR_CHARGES_COLUMNS,
  AWO_PMR_SOAP_CHARGES_COLUMNS,
  CHARGES_COLUMNS,
  SOAP_CHARGES_COLUMNS,
} from '~/components/dashboard/soapV2/charges/table/Columns'
import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'

export type ChargesColumnSubLabel = {
  label: string
}

export type SoapChargesColumn = {
  label: string
  width?: number
}

export type ChargesColumn = SoapChargesColumn & {
  id: number
  subLabels?: ChargesColumnSubLabel[]
}

export function useGetChargesColumns(isSoapCharges: false): ChargesColumn[]
export function useGetChargesColumns(isSoapCharges: true): SoapChargesColumn[]
export function useGetChargesColumns(
  isSoapCharges: boolean,
): ChargesColumn[] | SoapChargesColumn[] {
  const isAwoPmrRightRailEnabled = useSelector(
    getFeatureToggle(FeatureToggle.AWO_PMR_RIGHT_RAIL),
  )

  const soapChargesColumns = isAwoPmrRightRailEnabled
    ? AWO_PMR_SOAP_CHARGES_COLUMNS
    : SOAP_CHARGES_COLUMNS
  const chargesColumns = isAwoPmrRightRailEnabled
    ? AWO_PMR_CHARGES_COLUMNS
    : CHARGES_COLUMNS

  return (isSoapCharges ? soapChargesColumns : chargesColumns) as
    | ChargesColumn[]
    | SoapChargesColumn[]
}
